import loadable from '@loadable/component';

import './VerifyEmail.css';

export default loadable(() => {
  return import('./VerifyEmail.jsx');
});
